
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mortgages/landing",
      function () {
        return require("private-next-pages/mortgages/landing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mortgages/landing"])
      });
    }
  